
import React from 'react';
import GlobalErrorBoundary from './GlobalErrorBoundary';

// Re-export GlobalErrorBoundary as GlobalErrorHandler for backward compatibility
const GlobalErrorHandler = GlobalErrorBoundary;

export default GlobalErrorHandler;
